import React, { useState } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import API_URL from "../ApiUrl/ApiUrl";
import { Link } from "react-router-dom";

const Register = () => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${API_URL}/signup`, {
        firstname,
        lastname,
        email,
        password,
      });

      if (response.status === 200) {
        toast.success("Register successful!",{
          position:"top-center"
        });
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        toast.error("Registration failed. Please try again.",{
          position:"top-center"
        });
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An error occurred. Please try again.",{
          position:"top-center"
        }
      );
    }
  };

  return (
    <div>
      <div className="transper" style={{ width: "100%", height: "100px"}}>
      </div>
      <ToastContainer />
      <div className="login-container">
        <div className="image-section">
          <img
          style={{height: "300px", marginTop:'200px'}}
            src="https://i.ibb.co/FDtGqWt/cars1.png"
            alt="Register illustration"
          />
        </div>
        <div className="login-section">
          <div className="login-header">
            <h1>Register</h1>
          </div>
          <form id="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="firstname">First Name</label>
              <input
                className="login"
                type="text"
                id="firstname"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastname">Last Name</label>
              <input
                className="login"
                type="text"
                id="lastname"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                className="login"
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                className="login"
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="submit-btn">
              Submit
            </button>
            <p className="mt-4">
              Already have an account? <Link to="/login"><span>Login</span></Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;